import {
  Box,
  Card,
  CardContent,
  Typography,
  Stack,
  useTheme,
  Divider,
} from "@mui/material";
import CallCenter from "../../assets/img/png/10002.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faCalendarDays,
} from "@fortawesome/free-regular-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const contactInfo = [
  {
    icon: faEnvelope,
    title: "Email",
    value: "climatropical787@gmail.com",
    description: "Envie-nos um email a qualquer momento",
  },
  {
    icon: faPhone,
    title: "Telefone",
    value: "(+244) 941 392 971",
    description: "Ligue para nossa equipe",
  },
  {
    icon: faWhatsapp,
    title: "WhatsApp",
    value: "(+244) 941 392 971",
    description: "Atendimento rápido via WhatsApp",
  },
  {
    icon: faCalendarDays,
    title: "Horário de Atendimento",
    value: "Segunda a Sexta: 9h - 18h",
    description: "Sábado: 9h - 13h",
  },
];

export interface IContactInformation {
  //size: number;
}

const ContactInformation: React.FC<IContactInformation> = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Card
        sx={{
          height: "100%",
          backgroundColor: theme.palette.background.paper,
          boxShadow: theme.shadows[3],
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CardContent sx={{ p: 4, flex: 1 }}>
          <Typography
            variant="h5"
            component="h2"
            gutterBottom
            sx={{
              fontWeight: "bold",
              color: theme.palette.primary.main,
              mb: 4,
            }}
          >
            Informações de Contato
          </Typography>

          <Box sx={{ mb: 4, textAlign: "center" }}>
            <img
              src={CallCenter}
              alt="Call center specialist"
              style={{
                width: "100%",
                // maxWidth: "300px",
                height: "auto",
              }}
            />
          </Box>

          <Stack spacing={3}>
            {contactInfo.map((contact, index) => (
              <Box key={index}>
                <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                  <Box
                    sx={{
                      backgroundColor: theme.palette.primary.main,
                      color: "white",
                      borderRadius: "50%",
                      width: 40,
                      height: 40,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mr: 2,
                      flexShrink: 0,
                    }}
                  >
                    <FontAwesomeIcon icon={contact.icon} />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        color: theme.palette.text.primary,
                        mb: 0.5,
                      }}
                    >
                      {contact.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: theme.palette.primary.main,
                        fontWeight: "medium",
                        mb: 0.5,
                      }}
                    >
                      {contact.value}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: theme.palette.text.secondary }}
                    >
                      {contact.description}
                    </Typography>
                  </Box>
                </Box>
                {index < contactInfo.length - 1 && <Divider sx={{ mt: 2 }} />}
              </Box>
            ))}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ContactInformation;
